module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/315.cc16c7e2.png";